module.exports = __webpack_public_path__ + "img/thefraternity-white-text-only-powered.08438519.png";